module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4qHlh2oSFXWqQ3n8VSfO0G-a4cbbc696b63c4911582661f3ebfa584.jpg";